// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChipsDropdown-wrapper {
  padding: 4px 8px 4px 16px;
  border: 1px solid var(--color_primary_500);
  color: var(--color_primary_500);
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ChipsDropdown-wrapper button {
  padding: 0px;
}
.ChipsDropdown-wrapper:has(.disabled) {
  border: 1px solid var(--color_neutral_500);
}
.ChipsDropdown-wrapper.active {
  background-color: var(--color_primary_500);
  color: white;
}
.ChipsDropdown-wrapper.active .drop-icon {
  fill: white;
}
.ChipsDropdown-wrapper ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.ChipsDropdown-wrapper .selected-value {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 22px;
  column-gap: 4px;
  cursor: pointer;
}
.ChipsDropdown-wrapper .selected-value.disabled {
  color: var(--color_neutral_500);
  cursor: auto;
}
.ChipsDropdown-wrapper .selected-value.disabled .drop-icon {
  fill: var(--color_neutral_500);
}
.ChipsDropdown-wrapper .popover-content {
  height: auto;
  z-index: 999;
  top: 30px !important;
}
.ChipsDropdown-wrapper .popover-content.popover-align-left {
  right: auto !important;
  left: -17px !important;
}
.ChipsDropdown-wrapper .popover-content.popover-align-right {
  right: -10px !important;
  left: auto !important;
}
.ChipsDropdown-wrapper .popover-content.popover-hidden {
  display: none;
}
.ChipsDropdown-wrapper .popover-content .simple-card-container {
  padding: 0;
}
.ChipsDropdown-wrapper .popover-content .option {
  font-size: 14px;
  cursor: pointer;
  padding: 9.5px 24px;
  color: var(--color_neutral_800);
}
.ChipsDropdown-wrapper .popover-content .option span {
  min-width: 196px;
  white-space: pre;
}
.ChipsDropdown-wrapper .popover-content .option.active {
  font-weight: 600;
  background-color: var(--color_primary_500);
  color: var(--color_neutral_0);
}
.ChipsDropdown-wrapper .popover-content .option.active:hover {
  background-color: var(--color_primary_500);
  color: var(--color_neutral_0);
}
.ChipsDropdown-wrapper .popover-content .option:hover {
  background-color: var(--color_primary_100);
  color: var(--color_primary_500);
}
.ChipsDropdown-wrapper .popover-content .option.disabled {
  pointer-events: none;
  color: var(--color_neutral_500);
}`, "",{"version":3,"sources":["webpack://./src/components/ChipsDropdown/index.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,0CAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,0CAAA;AAAJ;AAGE;EACE,0CAAA;EACA,YAAA;AADJ;AAGI;EACE,WAAA;AADN;AAKE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAHJ;AAME;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAJJ;AAMI;EACE,+BAAA;EACA,YAAA;AAJN;AAMM;EACE,8BAAA;AAJR;AASE;EACE,YAAA;EACA,YAAA;EACA,oBAAA;AAPJ;AASI;EACE,sBAAA;EACA,sBAAA;AAPN;AAUI;EACE,uBAAA;EACA,qBAAA;AARN;AAWI;EACE,aAAA;AATN;AAYI;EACE,UAAA;AAVN;AAaI;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;AAXN;AAaM;EACE,gBAAA;EACA,gBAAA;AAXR;AAcM;EACE,gBAAA;EACA,0CAAA;EACA,6BAAA;AAZR;AAcQ;EACE,0CAAA;EACA,6BAAA;AAZV;AAgBM;EACE,0CAAA;EACA,+BAAA;AAdR;AAiBM;EACE,oBAAA;EACA,+BAAA;AAfR","sourcesContent":[".ChipsDropdown-wrapper {\n  padding: 4px 8px 4px 16px;\n  border: 1px solid var(--color_primary_500);\n  color: var(--color_primary_500);\n  border-radius: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  button {\n    padding: 0px;\n  }\n\n  &:has(.disabled) {\n    border: 1px solid var(--color_neutral_500);\n  }\n\n  &.active {\n    background-color: var(--color_primary_500);\n    color: white;\n\n    .drop-icon {\n      fill: white;\n    }\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .selected-value {\n    font-size: 14px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 22px;\n    column-gap: 4px;\n    cursor: pointer;\n\n    &.disabled {\n      color: var(--color_neutral_500);\n      cursor: auto;\n\n      .drop-icon {\n        fill: var(--color_neutral_500);\n      }\n    }\n  }\n\n  .popover-content {\n    height: auto;\n    z-index: 999;\n    top: 30px !important;\n\n    &.popover-align-left {\n      right: auto !important;\n      left: -17px !important;\n    }\n\n    &.popover-align-right {\n      right: -10px !important;\n      left: auto !important;\n    }\n\n    &.popover-hidden {\n      display: none;\n    }\n\n    .simple-card-container {\n      padding: 0;\n    }\n\n    .option {\n      font-size: 14px;\n      cursor: pointer;\n      padding: 9.5px 24px;\n      color: var(--color_neutral_800);\n\n      span {\n        min-width: 196px;\n        white-space: pre;\n      }\n\n      &.active {\n        font-weight: 600;\n        background-color: var(--color_primary_500);\n        color: var(--color_neutral_0);\n\n        &:hover {\n          background-color: var(--color_primary_500);\n          color: var(--color_neutral_0);\n        }\n      }\n\n      &:hover {\n        background-color: var(--color_primary_100);\n        color: var(--color_primary_500);\n      }\n\n      &.disabled {\n        pointer-events: none;\n        color: var(--color_neutral_500);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
